import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoginModalService {
    private closeDialogSubject = new Subject<void>();

    public closeDialog$ = this.closeDialogSubject.asObservable();

    public close() {
        this.closeDialogSubject.next();
    }
}
